<template>
  <KnowledgeList
    :pre-defined-keyword="$route.params.keyword"
    :hidden-columns="['approvalStatus']"
  />
</template>

<script>
import KnowledgeList from '@modules/knowledge/views/list'

export default {
  name: 'AllArticles',
  components: { KnowledgeList },
}
</script>
